import { Component, OnInit } from '@angular/core';
import { PricingService } from '../../services';
import { Message } from '../../classes/Message';
import { MessageService } from 'primeng';

@Component({
  selector: 'manage-discount-lookup',
  templateUrl: './manage-discount-lookup.component.html',
  styleUrls: ['./manage-discount-lookup.component.css'],
})
export class ManageDiscountLookupComponent implements OnInit {
  constructor(private pricingService: PricingService, public messageService: MessageService) {}

  isLoaded: boolean;
  discountLookup: any[][];
  viewSet: any[][] = [];

  selectedDiscount: any[] = [];

  rowsInPage: number = 28;
  firstRow: number = 0;
  sortField: string;
  sortOrder: number = 0;

  ngOnInit() {
    this.isLoaded = false;

    this.pricingService.getDiscountLookup().then((res) => {
      this.discountLookup = [];
      this.discountLookup.push(res.filter((x) => x.forSupplier));
      this.discountLookup.push(res.filter((x) => !x.forSupplier));

      this.setResults(0);
      this.setResults(1);

      console.log('Discount lookups: ', this.viewSet[0]);

      this.isLoaded = true;
    });
  }

  onGridLazyLoad(event: any, index: number) {
    this.firstRow = event.first;
    this.rowsInPage = event.rows;
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;

    console.log('Lazy load event: ', event);
    this.setResults(index);
  }

  onRowClick(event: any, index: number) {}

  setResults(index: number) {
    if (this.discountLookup[index]) {
      if (!this.viewSet) {
        this.viewSet = [];
      }
      this.viewSet[index] = this.discountLookup[index].slice(
        this.firstRow,
        this.firstRow + this.rowsInPage,
      );
    }

    //console.log("Viewset ", index, ": ", this.viewSet[index]);
  }

  cellEdit(item) {
    if (item.percentageReduction.trim() == '' || item.percentageReduction.trim() == '') {
      this.messageService.add(Message.Error('Percentage reduction cannot be empty', 'Error'));
      return;
    }

    console.log('Editing cell finished, saving: ', item);

    // update the reduction in the db
    this.pricingService.updateDiscountLookup(item).catch((res) => {
      console.log(res);
    });
  }
}
